import { generateEmailHead } from './generateEmailHead';
import { generateEmailBody } from './generateEmailBody';
export function generateHtml(formData, logoUrl, removeBranding, signatureHtml) {
    const data = Object.assign({}, formData);
    if (!data.main_html_content) {
        throw new Error(`No main_html_content found`);
    }
    if (formData.include_upcoming_latefee && formData.secondary_html_content && formData.main_html_content) {
        // We need to preprocess the latefee section,
        data.main_html_content = data.main_html_content.replace(/{{{PenaltiesSection}}}/g, data.secondary_html_content);
        if (!data.main_html_content) {
            throw new Error(`No main_html_content found after preprocessing`);
        }
    }
    return `
      <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
      <html data-editor-version="2" class="sg-campaigns" xmlns="http://www.w3.org/1999/xhtml">
    ${generateEmailHead()}
    ${generateEmailBody(data, logoUrl, removeBranding, signatureHtml)}
    </html>
  `;
}
//# sourceMappingURL=generateEmailTemplate.js.map